import dayjs from 'dayjs'

import { Form, onFieldValueChange } from '@eastcoal/formily/exports/core'

const clearError = (_: any, form: Form) => {
  const { startTime, endTime } = form.values
  const minDate = dayjs(startTime || new Date())

  if (minDate.isBefore(dayjs(endTime), 'm')) form.clearErrors('startTime')
}

export const startTimeEffect = () => {
  onFieldValueChange('endTime', clearError)
}
